import { render } from "./HotelDetailsView.vue?vue&type=template&id=7f137125"
import script from "./HotelDetailsView.vue?vue&type=script&lang=js"
export * from "./HotelDetailsView.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__